import { LitElement, html } from 'lit'

class SearchResult extends LitElement {
  constructor() {
    super()

    this.resultTitle = document.querySelector('.searchpage-heading')
    this.searchresult = document.querySelector('.search-result')
    this.listTitle = document.querySelector('.content-section__main h2')
    this.listContainer = document.querySelector('#search-result').total

    this.addEventListener('search-result', this.handleSearchResult)
    this.addEventListener('search-result-update', this.handleSearchResultUpdate)
    this.addEventListener('filter-update', this.handleFilterUpdate)
  }

  static properties = {}

  updateSearchResultVisibility() {
    let queryParams = window.location.search
    if (queryParams === '') {
      this.searchresult.style.display = 'none'
    } else {
      this.searchresult.style.display = 'flex'
    }
  }
  
  connectedCallback() {
    window.addEventListener('popstate', () => {
      this.updateSearchResultVisibility()
    })
    this.updateSearchResultVisibility()
  }

  handleSearchResult(event) {
    let searchValue = event.detail
    let totalValue = this.listContainer

    let title = `${totalValue} sökresultat för ${searchValue}`

    if (searchValue !== '' || searchValue !== undefined) {
      this.searchresult.style.display = 'flex'
      this.resultTitle.innerText = title
    }
  }

  handleSearchResultUpdate(event) {
      this.searchresult.innerHTML = event.detail.body
      this.searchresult.style.display = 'flex'
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('search-result', SearchResult)
